import { Badge } from './Badge'

type DetectionAlertCellProps = {
  alertSent: boolean
  screenshotUrl?: string | null
}

export function DetectionAlertCell({ alertSent, screenshotUrl }: DetectionAlertCellProps) {
  return (
    <div className="flex items-center gap-1.5">
      <Badge variant={alertSent ? 'success' : 'gray'}>
        {alertSent ? 'Sent' : 'No'}
      </Badge>
      {screenshotUrl && (
        <span title="Screenshot captured" className="text-gray-400">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4">
            <path fillRule="evenodd" d="M1 8a2 2 0 0 1 2-2h.93a2 2 0 0 0 1.664-.89l.812-1.22A2 2 0 0 1 8.07 3h3.86a2 2 0 0 1 1.664.89l.812 1.22A2 2 0 0 0 16.07 6H17a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8Zm13.5 3a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM10 14a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" clipRule="evenodd" />
          </svg>
        </span>
      )}
    </div>
  )
}
